import styled from 'styled-components'

export const StColumn = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.UI.SpacingPx.Space10};
`
